import { CursoComplementar } from '../../contexts';
import { FixtureCursoComplementar } from './curso-complementar.types';

export const cursoComplementarFixture: FixtureCursoComplementar = () => {
  const fixture: CursoComplementar = {
    codigo: '1',
    titulo: 'Teste Curso Complementar',
    url: 'https://estacio.br',
    resumo: undefined,
    cargaHorariaEmMinutos: undefined,
  };
  return {
    create: () => {
      const cursoComplementar = { ...fixture };

      return {
        codigo: function (param: string) {
          cursoComplementar.codigo = param;
          return this;
        },
        titulo: function (param: string) {
          cursoComplementar.titulo = param;
          return this;
        },
        url: function (param: string) {
          cursoComplementar.url = param;
          return this;
        },
        resumo: function (param: string) {
          cursoComplementar.resumo = param;
          return this;
        },
        cargaHorariaEmMinutos: function (param: number) {
          cursoComplementar.cargaHorariaEmMinutos = param;
          return this;
        },
        get: function () {
          return cursoComplementar;
        },
      };
    },
  };
};
